<ul>
  <li *ngFor="let race of races$ | async">
    <a [routerLink]="['/ranking/race-results', race.id]">{{race.name}}</a>
  </li>
  <li>
    <a routerLink="/ranking/season-results">Season standings</a>
  </li>
</ul>
